export default __webpack_public_path__ + "static/media/arrow-r.b9fe3a14.svg";